import React from 'react';

import { ThreeStepCtaBlockData } from 'api/cms';
import { Box } from 'components/Box';
import { TrackedPrimaryButtonLink } from 'components/Button';
import { Body, RichTextHeadline } from 'components/Text';
import { gutterWidth } from 'theme';

import { TreeStepCtaBlockStep } from './TreeStepCtaBlockStep';

const STEPS = ['One', 'Two', 'Three'];

type Props = {
  data: ThreeStepCtaBlockData;
  blockIndex: number;
  pageUpdated: string;
};

export function ThreeStepCtaBlock({ data, blockIndex, pageUpdated }: Props) {
  const { mainHeadline, mainText, buttonUrl, buttonText, imageSize } = data;
  const withImages = STEPS.some((step) => data[`step${step}Image`]);
  const withLinks = STEPS.some((step) => data[`step${step}Url`]);
  return (
    <Box
      data-qa-id={`three-step-cta-${blockIndex}`}
      display="flex"
      alignItems="center"
      width="100%"
      flexDirection="column"
      justifyContent="center"
    >
      {(mainHeadline || mainText) && (
        <Box width="100%" textAlign="center" mb={24}>
          {mainHeadline && (
            <RichTextHeadline mt="0">{mainHeadline}</RichTextHeadline>
          )}
          {mainText && (
            <Body
              analyticsData={{
                eventName: 'CMS Block',
                eventProperties: {
                  block_position: blockIndex,
                  block_type: 'Three Step CTA',
                },
              }}
              dangerouslySetInnerHTML={{
                __html: mainText,
              }}
            />
          )}
        </Box>
      )}
      <Box
        display="flex"
        alignItems={['center', null, null, 'stretch']}
        flexDirection={['column', 'column', 'column', 'row']}
        justifyContent="center"
        mx={[0, null, null, -gutterWidth / 2]}
        width={[1, null, null, `calc(100% + ${gutterWidth}px)`]}
      >
        {STEPS.map((step, index) => (
          <TreeStepCtaBlockStep
            key={step}
            blockIndex={blockIndex}
            data-qa-id={`step-${index}`}
            headline={data[`step${step}Headline`]}
            text={data[`step${step}Text`]}
            image={data[`step${step}Image`]}
            url={data[`step${step}Url`]}
            withImages={withImages}
            withLinks={withLinks}
            large={imageSize === 'LARGE'}
            pageUpdated={pageUpdated}
            step={step}
          />
        ))}
      </Box>

      {buttonText && buttonUrl && (
        <TrackedPrimaryButtonLink
          href={buttonUrl}
          mt={24}
          eventName="CMS Block"
          eventProperties={{
            block_position: blockIndex,
            block_type: 'Three Step Call to Action',
            cta_type: 'Button',
            page_updated: pageUpdated,
          }}
        >
          {buttonText}
        </TrackedPrimaryButtonLink>
      )}
    </Box>
  );
}

// eslint-disable-next-line import/no-default-export
export default ThreeStepCtaBlock;
